import { FlexBox, useIsMobile } from "@brg/ui";
import { FC } from "react";
import { ProjectEditPageGridLabel } from "../../styles";
import RadioButton from "shared/components/Radio/RadioButton";
import { Footnote, CopyLinkButton } from "../../styles";
import CopyLink24 from "shared/assets/24/CopyLink24";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import { AvailabilityAction } from "../../types";

interface IProps {
    availability: string;
    hideLabel?: boolean;
    onChange: (val: string) => void;
    onCopy: (e: any) => void;
    direction?: 'row' | 'column',
    isFolder?: boolean;
    disableItem?: string;
}
export const Availability: FC<IProps> = ({ availability, hideLabel, onChange, onCopy, direction = 'row', isFolder, disableItem = '' }) => {
    const {t} = useTranslation();
    const isMobile = useIsMobile();
    const isProjectEditPage = !!useRouteMatch('/edit')

    return (
        <FlexBox direction={direction} directionMobile={direction} {...direction === 'column' && { gy: 12 }}>
          {!hideLabel && (
            <ProjectEditPageGridLabel isProjectEditPage={isProjectEditPage} /*{...custom}*/  offsetBottomMobile={16}>
              {t('project_edit.availability_label')}
            </ProjectEditPageGridLabel>
          )}

                    <FlexBox direction={hideLabel ? 'row' : 'column'} directionMobile='column' width={'100%'} widthMobile={'100%'} gy={hideLabel && !isMobile ? 0 : 12}>
                      <RadioButton
                        checked={availability === AvailabilityAction.open}
                        onChange={() => onChange(AvailabilityAction.open)}
                        name="availability"
                        {...(disableItem === 'open' && { disabled: true })}
                      >
                        <ProjectEditPageGridLabel>
                          <FlexBox width="100%" direction="column" directionMobile="column" >
                            {t('project_edit.availability.open')}
                            <Footnote>
                              {t('project_edit.availability.open_footnote')}
                            </Footnote>
                          </FlexBox>
                        </ProjectEditPageGridLabel>
                      </RadioButton>
                      <FlexBox width="100%">
                        <RadioButton
                          checked={availability === AvailabilityAction.link}
                          onChange={() => onChange(AvailabilityAction.link)}
                          name="availability"
                          {...(disableItem === 'link' && { disabled: true })}
                        >
                          <ProjectEditPageGridLabel>
                            <FlexBox width="100%" direction="column" directionMobile="column" >
                              {t('project_edit.availability.link')}
                              <Footnote>
                                {isFolder ? t('folders.modal.availability') : t('project_edit.availability.link_footnote')}
                              </Footnote>
                            </FlexBox>
                          </ProjectEditPageGridLabel>
                        </RadioButton>
                        {availability === AvailabilityAction.link && (
                          <CopyLinkButton onClick={onCopy}>
                            <CopyLink24 />
                          </CopyLinkButton>
                        )}
                      </FlexBox>
                    </FlexBox>
        </FlexBox>
    )
}import { FlexBox, useIsMobile } from "@brg/ui";
import { FC } from "react";
import { ProjectEditPageGridLabel } from "../../styles";
import RadioButton from "shared/components/Radio/RadioButton";
import { Footnote, CopyLinkButton } from "../../styles";
import CopyLink24 from "shared/assets/24/CopyLink24";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import { AvailabilityAction } from "../../types";

interface IProps {
    availability: string;
    hideLabel?: boolean;
    onChange: (val: string) => void;
    onCopy: (e: any) => void;
    direction?: 'row' | 'column',
    isFolder?: boolean;
    disableItem?: string;
}
export const Availability: FC<IProps> = ({ availability, hideLabel, onChange, onCopy, direction = 'row', isFolder, disableItem = '' }) => {
    const {t} = useTranslation();
    const isMobile = useIsMobile();
    const isProjectEditPage = !!useRouteMatch('/edit')

    return (
        <FlexBox direction={direction} directionMobile={direction} {...direction === 'column' && { gy: 12 }}>
          {!hideLabel && (
            <ProjectEditPageGridLabel isProjectEditPage={isProjectEditPage} /*{...custom}*/  offsetBottomMobile={16}>
              {t('project_edit.availability_label')}
            </ProjectEditPageGridLabel>
          )}

                    <FlexBox direction={hideLabel ? 'row' : 'column'} directionMobile='column' width={'100%'} widthMobile={'100%'} gy={hideLabel && !isMobile ? 0 : 12}>
                      <RadioButton
                        checked={availability === AvailabilityAction.open}
                        onChange={() => onChange(AvailabilityAction.open)}
                        name="availability"
                        {...(disableItem === 'open' && { disabled: true })}
                      >
                        <ProjectEditPageGridLabel>
                          <FlexBox width="100%" direction="column" directionMobile="column" >
                            {t('project_edit.availability.open')}
                            <Footnote>
                              {t('project_edit.availability.open_footnote')}
                            </Footnote>
                          </FlexBox>
                        </ProjectEditPageGridLabel>
                      </RadioButton>
                      <FlexBox width="100%">
                        <RadioButton
                          checked={availability === AvailabilityAction.link}
                          onChange={() => onChange(AvailabilityAction.link)}
                          name="availability"
                          {...(disableItem === 'link' && { disabled: true })}
                        >
                          <ProjectEditPageGridLabel>
                            <FlexBox width="100%" direction="column" directionMobile="column" >
                              {t('project_edit.availability.link')}
                              <Footnote>
                                {isFolder ? t('folders.modal.availability') : t('project_edit.availability.link_footnote')}
                              </Footnote>
                            </FlexBox>
                          </ProjectEditPageGridLabel>
                        </RadioButton>
                        {availability === AvailabilityAction.link && (
                          <CopyLinkButton onClick={onCopy}>
                            <CopyLink24 />
                          </CopyLinkButton>
                        )}
                      </FlexBox>
                    </FlexBox>
        </FlexBox>
    )
}